import { Controller } from '@hotwired/stimulus'

const ONLOAD_CALLBACK = 'thqRecaptchaOnload'
const pending = new Set()

export default class extends Controller {
  static targets = ['widget', 'token', 'submit']
  static values = { sitekey: String, src: String }

  connect() {
    this.submitTarget.disabled = true

    if (window.grecaptcha?.render) {
      this.render()
    } else {
      pending.add(this)
      this.loadScript()
    }
  }

  disconnect() {
    pending.delete(this)
  }

  loadScript() {
    if (window[ONLOAD_CALLBACK]) return

    window[ONLOAD_CALLBACK] = () => {
      pending.forEach((controller) => controller.render())
      pending.clear()
    }

    const script = document.createElement('script')
    script.src = `${this.srcValue}?onload=${ONLOAD_CALLBACK}&render=explicit`
    script.async = true
    script.defer = true
    document.head.appendChild(script)
  }

  render() {
    window.grecaptcha.render(this.widgetTarget, {
      sitekey: this.sitekeyValue,
      callback: (token) => this.verified(token),
    })
    this.widgetTarget.dataset.recaptchaStatus = 'loaded'
  }

  verified(token) {
    this.tokenTarget.value = token
    this.submitTarget.disabled = false
    this.widgetTarget.dataset.recaptchaStatus = 'success'
  }
}
